import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "permission-mask d-flex justify-content-center align-items-center" }
const _hoisted_2 = { class: "permission-mask-label" }

import { computed, ref, watch } from 'vue'
import FormRow from "@/components/Common/FormRow.vue"
import PermissionItem from "@/components/UserRoleForm/PermissionItem.vue";
import UserRoleService from "@/services/models/UserRole";
import SelectRoleChecker from '@/router/selectRoleChecker'
import permissionType from "@/types/permission"
import getPermissionListResponseType from '@/types/responses/getPermissionList'
import getRoleTemplateResponseType from '@/types/responses/getRoleTemplate'
import getPermissionListRequestType from '@/types/requests/getPermissionList'
import {officeType, departmentType} from "@/types/requests/userRoleSearchForm";
import Api from "@/services/api/ApiServiceFabrick";
import { permissionDisplayName } from "@/services/consts";
import {
  MANAGEMENT_OFFICE,
  SUB_MANAGEMENT_OFFICE,
  INSTALLATION_OFFICE,
  OPERATION_OFFICE,
  DEPARTMENT
} from "@/services/consts/user_role";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'PermissionForm',
  props: {
    windowInnerWidth: {},
    modelValue: {},
    roleTemplateList: {},
    selectedOffice: {},
    selectedDepartment: {},
    errors: {},
    isEdit: { type: Boolean }
  },
  emits: [
  'update:modelValue',
  'changeBtnStatus'
],
  setup(__props: any, { emit: __emit }) {

const permissions = ref({} as getPermissionListResponseType)
const permissionList = ref({} as getPermissionListResponseType)
const selectRoleTemplateItems = ref([] as string[]);
const selectedItem = ref("" as string)
const isPermissionListShow = ref(false)
const maskText = ref(i18n.global.t('pages.userRoles.form.mask.needSelect'))
const props = __props
const emits = __emit

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

watch(() => permissions, () => {
  formatedPermission()
},{deep:true})

watch(() => props.selectedOffice, () => {
  initPermission()
})
watch(() => props.selectedDepartment, () => {
  initPermission()
})
watch(() => props.isEdit, () => {
  initPermission()
})

function getPermissionList(){
  const param = makeParam()
  Api().getPermissionList(param).then((data: getPermissionListResponseType) => {
    permissionList.value = data
    setPermission()
    isPermissionListShow.value = true
    emits('changeBtnStatus', true);
  }).catch((error: any) => {
    return console.log(error.response)
  })
}
function makeParam(){
  let selectedOrganizationType = "";
  let selectedOrganization = {} as {id: number|null, name: string, type?: string, operation_office_id?: number|null}
  if (!props.selectedDepartment || !props.selectedDepartment.id) {
    selectedOrganizationType = getSelectOrganizationType()
    selectedOrganization = props.selectedOffice
  } else {
    selectedOrganizationType = DEPARTMENT.type
    selectedOrganization = props.selectedDepartment
  }

  const param:getPermissionListRequestType =
  {
    id: selectedOrganization.id,
    type: selectedOrganizationType,
    name: selectedOrganization.name,
  }
  return param
}
function getSelectOrganizationType(){
  const organizations = [
    MANAGEMENT_OFFICE,
    SUB_MANAGEMENT_OFFICE,
    INSTALLATION_OFFICE,
    OPERATION_OFFICE,
    DEPARTMENT
  ]
  const organization = organizations.find( (org) => {
    return org.type.includes(props.selectedOffice.type)
  })
  return organization.type
}

function initPermission(){
  isPermissionListShow.value = false
  maskText.value = i18n.global.t('pages.userRoles.form.mask.needSelect')
  emits('changeBtnStatus', false);
  if(!props.isEdit) permissions.value = {}
  permissionList.value = {}
  selectedItem.value = ""

  let isDepartment = false;
  const current_role = SelectRoleChecker.getCurrentRole()
  if(current_role.organization_type == DEPARTMENT.type) isDepartment = true

  if (
    ( props.isEdit && Object.keys(modelValue.value).length === 0 ) ||
    ( Object.keys(props.roleTemplateList).length === 0 ) ||
    ( !props.selectedOffice || !props.selectedOffice.id ) ||
    ( isDepartment && (!props.selectedDepartment || !props.selectedDepartment.id) )
  ) {
    return delayInitPermission()
  }

  // display permission list
  maskText.value = i18n.global.t('pages.userRoles.form.mask.loading')
  selectRoleTemplateItems.value = getRoleTemplateNames(props.roleTemplateList)
  getPermissionList()
}

function delayInitPermission(){
  setTimeout(() => {initPermission()},1000)
}

function setPermission(){
  if(!modelValue.value) return
  permissions.value = UserRoleService.formatPermissionsToForm(modelValue.value);
}

function formatedPermission(){
  modelValue.value = UserRoleService.formatPermissionsToRequest(permissions.value);
}

function setRoleTemplate(){
  const selectedTemplate = props.roleTemplateList.find( (template) =>{
    return template.name == selectedItem.value
  })
  if(selectedTemplate) {
    const formatedPermissions = UserRoleService.formatPermissionsToForm(selectedTemplate.permissions);
    permissions.value = JSON.parse(JSON.stringify(formatedPermissions))
  }
}

function getRoleTemplateNames(data: getRoleTemplateResponseType[]){
  let templateNameList = [] as string[]
  let rejectedType = [] as string[]
  const selectedOrganizationType = getSelectOrganizationType()
  switch(selectedOrganizationType){
    case MANAGEMENT_OFFICE.type:
      break;
    case SUB_MANAGEMENT_OFFICE.type:
      rejectedType = [
        MANAGEMENT_OFFICE.type
      ]
      break;
    case INSTALLATION_OFFICE.type:
      rejectedType = [
        MANAGEMENT_OFFICE.type,
        SUB_MANAGEMENT_OFFICE.type,
        OPERATION_OFFICE.type,
        DEPARTMENT.type
      ]
      break;
    case OPERATION_OFFICE.type:
      rejectedType = [
        MANAGEMENT_OFFICE.type,
        SUB_MANAGEMENT_OFFICE.type,
        INSTALLATION_OFFICE.type
      ]
      break;
    case DEPARTMENT.type:
      rejectedType = [
        MANAGEMENT_OFFICE.type,
        SUB_MANAGEMENT_OFFICE.type,
        INSTALLATION_OFFICE.type
      ]
      break;
  }

  data.forEach((permission) => {
    if(rejectedType.includes(permission.organization_type)) return
    templateNameList.push(permission.name)
  })
  return templateNameList
}


return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isPermissionListShow.value)
      ? (_openBlock(), _createBlock(FormRow, {
          key: 0,
          title: _unref(i18n).global.t('pages.userRoles.form.template'),
          windowInnerWidth: props.windowInnerWidth,
          required: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      label: _unref(i18n).global.t('pages.userRoles.form.selectTemplate'),
                      modelValue: selectedItem.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItem).value = $event)),
                      items: selectRoleTemplateItems.value,
                      clearable: true
                    }, null, 8, ["label", "modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, { onClick: setRoleTemplate }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.userRoles.form.button.apply')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title", "windowInnerWidth"]))
      : _createCommentVNode("", true),
    _createVNode(FormRow, {
      title: _unref(i18n).global.t('pages.userRoles.form.permission'),
      windowInnerWidth: props.windowInnerWidth,
      required: true
    }, {
      default: _withCtx(() => [
        (__props.errors)
          ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item,
                    class: "ml-3 mt-6 text-error"
                  }, _toDisplayString(item), 1))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            (isPermissionListShow.value)
              ? (_openBlock(), _createBlock(_component_v_col, {
                  key: 0,
                  cols: "10"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissionList.value, (actions, permissionName) => {
                      return (_openBlock(), _createBlock(PermissionItem, {
                        key: permissionName,
                        label: _unref(permissionDisplayName)[permissionName],
                        permissionName: String(permissionName),
                        modelValue: permissions.value[permissionName],
                        "onUpdate:modelValue": ($event: any) => ((permissions.value[permissionName]) = $event),
                        actionList: actions
                      }, null, 8, ["label", "permissionName", "modelValue", "onUpdate:modelValue", "actionList"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_col, {
                  key: 1,
                  cols: "12"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, _toDisplayString(maskText.value), 1)
                    ])
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "windowInnerWidth"])
  ], 64))
}
}

})